import Translator, { __ } from "services/Translator";
//Auth module
import PrivateRoute from "routes/PrivateRoute";
import OpenRoute from "routes/OpenRoute";
import ChatRoute from "routes/ChatRoute";
import Spinner from "elements/Spinner";

// import external modules
import React, { Component, lazy, Suspense } from "react";
import { BrowserRouter, Switch, Redirect } from "react-router-dom";

const LangFixer = lazy(() => import("pages/LangFixer"));

const Landing = lazy(() => import("pages/Landing"));
const UserDashboard = lazy(() => import("pages/UserDashboard"));

const Promotions = lazy(() => import("pages/Promotions"));
const TermsAndconditions = lazy(() => import("pages/TermsAndconditions"));
const PrivacyPolicy = lazy(() => import("pages/PrivacyPolicy"));
const BonusTerms = lazy(() => import("pages/BonusTerms"));
const AMLPolicy = lazy(() => import("pages/AMLPolicy"));
const ResponsibleGaming = lazy(() => import("pages/ResponsibleGaming"));
const About = lazy(() => import("pages/About"));
const ProvablyFair = lazy(() => import("pages/ProvablyFair"));

const Vip = lazy(() => import("pages/Vip"));
const Rewards = lazy(() => import("pages/Rewards"));
const Games = lazy(() => import("pages/Games"));
const GamePlay = lazy(() => import("pages/GamePlay"));
const FAQ = lazy(() => import("pages/FAQ"));
const Races = lazy(() => import("pages/Races"));
const RaffleTickets = lazy(() => import("pages/RaffleTickets"));

const Blogs = lazy(() => import("pages/Blogs"));
const BlogDetails = lazy(() => import("pages/BlogDetails"));

// auth pages
const RecoverPassword = lazy(() => import("pages/auth/RecoverPassword"));
const ResetPassword = lazy(() => import("pages/auth/ResetPassword"));

// import Chat from "elements/Chat";
const Chat = lazy(() => import("elements/Chat"));
const NoMatch = lazy(() => import("pages/NoMatch"));

//Stores
const Stores = lazy(() => import("pages/Stores"));

const WelcomeSpin = lazy(() => import("pages/WelcomeSpin"));

//Tickets
const Tickets = lazy(() => import("pages/Tickets"));
const TicketDetails = lazy(() => import("pages/TicketDetails"));

class OpenRoutes extends Component {
  render() {
    return (
      <BrowserRouter basename={"/" + Translator.getSelectedLanguage().code + "/"}>
        <Switch>
          <OpenRoute exact path="/" component={Landing} />
          <OpenRoute exact path="/callback" />
          <OpenRoute exact path="/account-activated" activated={true} component={Landing} />
          <OpenRoute exact path="/refer/:referral_code" component={Landing} />
          <OpenRoute exact path="/promotions" component={Promotions} />
          <OpenRoute exact path="/terms-and-conditions" component={TermsAndconditions} />
          <OpenRoute exact path="/privacy-policy" component={PrivacyPolicy} />
          <OpenRoute exact path="/provably-fair" component={ProvablyFair} />
          <OpenRoute exact path="/bonus-terms" component={BonusTerms} />
          <OpenRoute exact path="/aml-policy" component={AMLPolicy} />
          <OpenRoute exact path="/responsible-gaming" component={ResponsibleGaming} />
          <OpenRoute exact path="/about" component={About} />

          <OpenRoute exact path="/vip" component={Vip} />
          <OpenRoute exact path="/faq" component={FAQ} />
          <OpenRoute exact path="/games/:category" component={Games} />
          <OpenRoute exact path="/play/:slug/:mode?" component={GamePlay} />
          {/* auth pages */}
          <OpenRoute exact path="/recover-password" component={RecoverPassword} />
          <OpenRoute exact path="/reset-password/:userId/:code" component={ResetPassword} />

          <OpenRoute exact path="/blogs" component={Blogs} />
          <OpenRoute exact path="/races" component={Races} />
          {/* <OpenRoute exact path="/raffle-tickets" component={RaffleTickets} /> */}
          <OpenRoute exact path="/blog-details/:slug" component={BlogDetails} />
          <OpenRoute exact path="/exclusive" component={WelcomeSpin} />
          <OpenRoute exact path="/registration" component={Landing} />
          {/* <Redirect path="*" to="/" /> */}
          {/* <OpenRoute path="*" component={NoMatch} status={404} /> */}
          <OpenRoute path="*" component={LangFixer} />
        </Switch>
      </BrowserRouter>
    );
  }
}

class PrivateRoutes extends Component {
  render() {
    return (
      <BrowserRouter basename={"/" + Translator.getSelectedLanguage().code + "/"}>
        <Switch>
          <PrivateRoute exact path="/" component={Landing} />

          <PrivateRoute exact path="/games/:category" component={Games} />
          <PrivateRoute exact path="/play/:slug/:mode?" component={GamePlay} />
          <PrivateRoute exact path="/dashboard/:tab?" component={UserDashboard} />
          <PrivateRoute exact path="/promotions" component={Promotions} />
          <PrivateRoute exact path="/faq" component={FAQ} />
          <PrivateRoute exact path="/terms-and-conditions" component={TermsAndconditions} />
          <PrivateRoute exact path="/privacy-policy" component={PrivacyPolicy} />
          <PrivateRoute exact path="/provably-fair" component={ProvablyFair} />
          <PrivateRoute exact path="/bonus-terms" component={BonusTerms} />
          <PrivateRoute exact path="/aml-policy" component={AMLPolicy} />
          <PrivateRoute exact path="/responsible-gaming" component={ResponsibleGaming} />
          <PrivateRoute exact path="/about" component={About} />
          <PrivateRoute exact path="/vip" component={Vip} />
          <PrivateRoute exact path="/rewards" component={Rewards} />
          <PrivateRoute exact path="/promotions" component={Promotions} />

          <PrivateRoute exact path="/blogs" component={Blogs} />
          <PrivateRoute exact path="/races" component={Races} />
          <PrivateRoute exact path="/raffle-tickets" component={RaffleTickets} />
          <PrivateRoute exact path="/blog-details/:slug" component={BlogDetails} />
          <ChatRoute exact path="/chat" component={Chat} />

          <PrivateRoute exact path="/tickets" component={Tickets} />
          <PrivateRoute exact path="/ticket-details/:id" component={TicketDetails} />

          <PrivateRoute exact path="/store" component={Stores}></PrivateRoute>
          <PrivateRoute exact path="/exclusive" component={WelcomeSpin} />

          <PrivateRoute path="*" component={LangFixer} />
          {/* <PrivateRoute path="*" component={NoMatch} status={404} /> */}
          {/* <Redirect path="*" to="/" /> */}
        </Switch>
      </BrowserRouter>
    );
  }
}

export { OpenRoutes, PrivateRoutes };
